import { render, staticRenderFns } from "./kasaraporu.vue?vue&type=template&id=47fa5b7b&"
import script from "./kasaraporu.vue?vue&type=script&lang=js&"
export * from "./kasaraporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports